(() => {
  const dialog = document.getElementById('mv-product-reviews-modal');
  if (!dialog || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const frame = dialog.querySelector('iframe');
  const loading = dialog.querySelector('.mv-reviews-loading');
  let trigger;
  let previousOverflow;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mv-reviews-open]');
    if (!button || dialog.open) return;
    event.preventDefault();
    trigger = button;
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    if (!frame.hasAttribute('src')) frame.src = frame.dataset.src;
  });
  dialog.querySelector('.mv-reviews-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow || '';
    if (trigger?.isConnected) trigger.focus({ preventScroll: true });
  });
  frame.addEventListener('load', () => { loading.hidden = true; });
  window.addEventListener('message', (event) => {
    if (event.origin !== 'https://loox.io' || event.source !== frame.contentWindow) return;
    let message = event.data;
    if (typeof message === 'string') { try { message = JSON.parse(message); } catch { return; } }
    if (!message || message.type !== 'resize') return;
    const height = Number(message.height);
    if (Number.isFinite(height) && height > 0 && height < 1000000) {
      frame.style.height = `${Math.ceil(height)}px`;
      loading.hidden = true;
    }
  });
})();
